import React, { useEffect, useState } from "react";
import styles from "../styles/register.module.css";
import { set } from "lodash";
import { Checkbox, List, ListItem, Modal, ModalDialog, Sheet } from "@mui/joy";
import { Button, Input, TextField } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from "react-router-dom";

const RegisterWaitingPresentationSms: React.FC<any> = (props: any) => {

    const [phoneNumber, setPhoneNumber] = useState("010");
    const [open, setOpen] = useState(false);
    const [submitStatus, setSubmitStatus] = useState("");
    const [agree, setAgree] = useState(false);
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {

        // 전화번호가 11자리 이상이거나 010으로 시작하지 않으면 disabled
        if (phoneNumber.length === 11 && agree) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }

    }, [phoneNumber, agree]);

    const typePhoneNumber = (e: React.ChangeEvent<HTMLInputElement>) => {

        const { value } = e.target;

        // 숫자(0-9)만 남기기
        const onlyNumbers = value.replace(/\D/g, "");

        // 010으로 시작하지 않으면 초기화
        if (onlyNumbers.length > 0 && !onlyNumbers.startsWith("010")) {
            setPhoneNumber("010");
            return;
        }

        // 최대 11자리까지만 허용
        if (onlyNumbers.length > 11) return;

        console.log(onlyNumbers);

        // 상태 업데이트
        setPhoneNumber(onlyNumbers);

    }

    const handleClose = () => {
        setOpen(false);
    }

    const submit = async () => {

        try{

            if(disabled) {
                return;
            }
    
            setLoading(true);

            const response = await fetch("https://peetsunbae.com/waiting/submitpresentationsms", {
                method : "POST",
                headers : {
                    "Content-Type": "application/json"
                },
                body : JSON.stringify({
                    phoneNumber: phoneNumber,
                })
            })

            const result = await response.json();
            console.log(result);
            setLoading(false);

            if(result.message === "success"){
                navigate("/registerpresentationfinish", {
                    state: {
                    }
                });
            }else{
                alert("전송이 실패했습니다. 1688-5786으로 문의해주세요.");
            }

        }catch(e){
            console.log(e);
        }


    }


    return (
        <div>
            <div style={{
                width: "90.6%",
                margin: "0 auto",
            }}>
                <div className={
                    styles.titleText3
                }>
                    수능선배 샤학관 N수반<br></br>사전예약 안내문자 보내드릴게요!
                </div>
                <div style={{
                    color: "#676767",
                    fontWeight: 300,
                    fontSize: "0.836rem",
                    marginTop: "0.64rem"
                }}>
                    문자 수신함을 꼭 확인해주세요.
                </div>

                <div className={`${styles.questionText} ${styles.third}`}>
                    휴대폰 번호만 적어주세요
                </div>

                <div className={styles.inputWrapper}>
                    <div className={styles.inputDiv}>
                        <input value={phoneNumber} onChange={typePhoneNumber} placeholder="휴대폰 번호를 적어주세요" className={styles.input} type="text" maxLength={11} autoFocus={true} inputMode="numeric" pattern="\d*" >

                        </input>
                    </div>
                </div>

                {/* <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "2.51rem"
                }}>
                    <img src="/img/bell3d2.webp"
                        style={{
                            width: "11.25rem"
                        }}
                    />
                </div> */}
                
                <div style={{
                    position : "fixed",
                    bottom: "1.5rem",
                    width: "90.6%",
                }}>
                    <div className={styles.submitBtnDiv}>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "12px",
                            marginTop: "10px",
                            justifyContent: "space-between",
                            paddingRight: "6px"
                        }}>
                            <Checkbox
                                color={
                                    submitStatus === "noAgree" ? "danger" : "neutral"
                                }
                                checked={agree}
                                onChange={(e: any) => {
                                    setAgree(e.target.checked);
                                }}
                                label={<span style={{
                                    fontWeight: 400,
                                    marginLeft: "2px",
                                    fontSize: "13px",
                                    color: submitStatus === "noAgree" ? "#d3232f" : "gray",
                                    display: "flex",
                                    alignItems: "center"
                                }}

                                >
                                    개인정보 수집 및 마케팅 정보 수신 동의
                                </span>}
                            />
                            <div style={{
                                fontWeight: 400,
                                fontSize: "12px",
                                color: "gray",
                                cursor: "pointer"
                            }}
                                onClick={() => {
                                    setOpen(true);
                                }}
                            >
                                더보기 &gt;
                            </div>
                        </div>
                        <Button onClick={submit} variant="contained" fullWidth sx={{ height: "72px", backgroundColor: "#3c3c3c", color: "white", fontWeight: 700, fontSize: "20px", "&:hover": { backgroundColor: "rgb(100,100,100)" }, "@media (max-width : 1024px)": { fontSize: "16px", height: '55.5px' } }}
                        disabled={disabled}
                        >
                            {
                                !loading ?
                                    "안내문자 받기"
                                    :
                                    <CircularProgress
                                        color="inherit"
                                    />
                            }
                        </Button>
                    </div>

                </div>

            </div>

            <Modal
                open={open}
                onClose={handleClose}
                sx={{
                    backdropFilter: "blur(0px)",
                }}
            >
                <ModalDialog sx={{
                    borderRadius: "10px",
                    overflowY: "auto",
                    minWidth: "250px"
                }}>
                    <div style={{
                        width: "100%",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        paddingTop: "10px",
                        paddingBottom: "10px",
                        fontSize: "11px"
                    }}>
                        <span style={{
                            fontWeight: 500
                        }}>[개인정보 수집 및 마케팅 정보 수신 동의]<br></br><br></br></span>
                        수능선배 샤학관은 설명회 신청자 관리를 위해 개인정보를 수집·이용하며,
                        입시 정보, 이벤트, 할인 행사, 신규 모집 등 다양한 소식을 제공하기 위해 마케팅 정보 수신에 대한 동의를 요청합니다.<br></br><br></br>

                        - 수집 항목: 이름, 연락처 등 수능선배 샤학관 마케팅 활용 관련 개인 정보<br></br>
                        - 수집 및 이용 목적: 설명회 신청 및 관리, 프로그램·이벤트 안내, 입시 정보 제공, 서비스 개선<br></br>
                        - 보유 및 이용 기간: 수집일로부터 동의 철회 시까지<br></br>
                        - 유의사항: 개인정보 제공 및 마케팅 수신 동의는 거부하실 수 있으나, 이 경우 설명회 신청 및 관련 혜택 제공이 제한될 수 있습니다.<br></br>
                        - 철회 안내: 동의 후에도 언제든지 마케팅 수신을 거부하거나 개인정보 삭제를 요청하실 수 있습니다.<br></br>

                    </div>
                </ModalDialog>
            </Modal>
        </div>
    )
}

export default RegisterWaitingPresentationSms;